var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
export var BoxEditButtons = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t/* Centre the controls on the anchor point (the box centre). */\n\ttransform: translate(-50%, -50%);\n"], ["\n\t/* Centre the controls on the anchor point (the box centre). */\n\ttransform: translate(-50%, -50%);\n"])));
var templateObject_1;
